
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Flowsheet = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect y="-0.2" width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <path d="M6.6,20.5a2.4,2.4,0,0,1-2.3-2.3V2.6H2.8V18.2A3.8,3.8,0,0,0,6.6,22H22.2V20.5Z"></path>
            <polygon points="12.5 10.6 15.4 13.5 22.1 6.8 21.1 5.7 15.4 11.4 12.5 8.5 5.7 15.2 6.8 16.3 12.5 10.6"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

Flowsheet.defaultProps = {
  title: 'Flowsheet',
};

export default Flowsheet;
